import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'
import Select from 'react-select'
import moment from 'moment'
import Datetime from 'react-datetime'
import LinkedToggle from '../misc/LinkedToggle'
import LinkedObjectPickerInput from '../inputs/LinkedObjectPickerInput'

class LinkedInput extends Component {
  getValueFromPath (path) {
    var obj = this.props.context.state
    var stack = path.split('.')
    while (stack.length) {
      obj = obj[stack.shift()]
    }
    return obj
  }
  setValueAtPath (path, value) {
    var obj = this.props.context.state
    var current = obj
    var stack = path.split('.')
    while (stack.length > 1) {
      current = current[stack.shift()]
    }
    current[stack.shift()] = value
    return obj
  }
  constructor (props) {
    super(props)
    this.state = {
      value: this.getValueFromPath(this.props.path),
      editable: (props.editable !== undefined)
      ? props.editable
      : true
    }
  }
  componentWillReceiveProps (props) {
    if (this.state.value === this.getValueFromPath(this.props.path) && this.state.editabe === props.editable) {
      return false
    }
    this.setState({
      editable: (props.editable !== undefined)
      ? props.editable
      : true,
      value: this.getValueFromPath(this.props.path)
    })
  }
  validate () {
    if (!this.props.validate) return true
    return !!(((this.type.prototype.getValueFromPath.call(this, this.props.path) || '') + '').match(this.props.validate))
  }
  handleListChange (e) {
    if (e == null) {
      this.props.context.setState(this.setValueAtPath(this.props.path, null))
      this.setState({
        value: this.getValueFromPath(this.props.path)
      })
    } else {
      this.props.context.setState(this.setValueAtPath(this.props.path, e.value || (this.props.nullable ? null : '')))
      this.setState({
        value: this.getValueFromPath(this.props.path)
      })
    }
    this.props.context.forceUpdate()
  }
  handleDateChange (e) {
    this.props.context.setState(this.setValueAtPath(this.props.path, e.toISOString() || (this.props.nullable ? null : '')))
    this.setState({
      value: this.getValueFromPath(this.props.path)
    })
    this.props.context.forceUpdate()
  }
  handleBooleanChange (e) {
    this.props.context.setState(this.setValueAtPath(this.props.path, e.target.checked || (this.props.nullable ? null : false)))
    e.target['value'] = e.target.checked
    this.setState({
      value: this.getValueFromPath(this.props.path)
    })
    this.props.context.forceUpdate()
  }
  handleChange (e) {
    this.props.context.setState(this.setValueAtPath(this.props.path, e.target.value || (this.props.nullable ? null : '')))
    this.setState({
      value: this.getValueFromPath(this.props.path)
    })
    this.props.context.forceUpdate()
  }
  emptyValue (val) {
    if (!val) return ''
    return val
  }
  render () {
    ReactTooltip.rebuild()
    var type = this.props.type
    if (type === 'string') { type = 'text' }

    if (type === 'date') {
      return (
        <div className={this.props.path.replace(/\./g, '-') + ' linked-input-wrapper'}>
          {(this.props.validate && this.state.editable && !this.props.hideRequired) && <div data-tip={this.props.errorMessage} id='required-field-marker'><i className='fa fa-fw fa-exclamation-circle' /></div>}
          <Datetime
            key={this.props.path.replace(/\./g, '-')}
            name={this.props.name || ''}
            inputProps={{disabled: !this.state.editable}}
            value={this.state.value && moment(this.state.value)}
            onChange={e => {
              this.handleDateChange(e)
              if (this.props.onChange) this.props.onChange(e)
            }}
            dateFormat={'YYYY-MM-DD'}
            timeFormat={'HH:mm:ss'} />
          {this.props.button && <button disabled={this.props.button.disabled} className={(this.props.button.hidden ? 'hidden' : 'btn btn-primary linkedinput-callback-button')} onClick={() => this.props.button.callback()}><i className={'fa fa-fw ' + this.props.button.icon} /></button>}
        </div>
      )
    } else if (type === 'checkbox' || type === 'boolean') {
      return <div>
        <LinkedToggle {...this.props} disabled={!this.state.editable} />
      </div>
    } else if (type === 'reference') {
      let referenceNamespace = this.props.referenceNamespace
      if (referenceNamespace == null) {
        return <div>
          <LinkedObjectPickerInput {...this.props} disabled={!this.state.editable} />
        </div>
      } else {
        let comps = referenceNamespace.split('/')
        return <div>
          <LinkedObjectPickerInput {...this.props} disabled={!this.state.editable} components={comps[0]} systems={comps[1]} />
        </div>
      }
    } else if (type === 'list' && this.props.listItems != null) {
      var items = this.props.listItems.split(',')
      var itemList = []
      for (var i = 0; i < items.length; i++) {
        itemList.push({value: items[i]})
      }
      if (this.state.editable) {
        return <div>
          <Select
            options={itemList}
            value={this.state.value}
            labelKey='value'
            valueKey='value'
            clearable={this.state.editable ? this.props.button : false}
            disabled={this.state.editable ? '' : 'readonly'}
            onChange={(e) => {
              this.handleListChange(e)
              if (this.props.onChange) this.props.onChange(e)
            }} />
        </div>
      } else {
        return <div className={this.props.path.replace(/\./g, '-') + ' linked-input-wrapper'}>
          <input
            key={this.props.path.replace(/\./g, '-')}
            name={this.props.name || ''}
            type={'text'}
            value={this.emptyValue(this.state.value)}
            readOnly={this.state.editable ? '' : 'readonly'}
            className={'form-control' + (this.props.className || '') + (this.props.button ? ' linkedinput-with-button ' : '')}
            placeholder={this.props.placeholder}
          />
        </div>
      }
    } else {
      return (
        <div className={this.props.path.replace(/\./g, '-') + ' linked-input-wrapper'}>
          {(this.props.validate && this.state.editable && !this.props.hideRequired) &&
          <div data-tip={this.props.errorMessage} id='required-field-marker'><i className='fa fa-fw fa-exclamation-circle' /></div>}
          <input
            key={this.props.path.replace(/\./g, '-')}
            name={this.props.name || ''}
            min={this.props.numberMin || ''}
            max={this.props.numberMax || ''}
            onChange={(e) => {
              this.handleChange(e)
              if (this.props.onChange) this.props.onChange(e)
            }}
            onKeyUp={(e) => {
              this.handleChange(e)
              if (this.props.onChange) this.props.onChange(e)
            }}
            onKeyDown={(e) => {
              if (this.props.onKeyDown) this.props.onKeyDown(e)
            }}
            type={type && this.state.editable ? (type || 'text') : 'text'}
            value={this.emptyValue(this.state.value)}
            readOnly={this.state.editable ? '' : 'readonly'}
            className={'form-control' + (this.props.className || '') + (this.props.button ? ' linkedinput-with-button ' : '')}
            placeholder={this.props.placeholder}
          />
          {this.props.button && <button disabled={this.props.button.disabled}
            className={(this.props.button.hidden ? 'hidden' : 'btn btn-primary linkedinput-callback-button')}
            onClick={() => this.props.button.callback()}>
            <i className={'fa fa-fw ' + this.props.button.icon} />
          </button>}
          <span className='error-message'>{this.props.errorMessage}</span>
        </div>
      )
    }
  }
}
export default LinkedInput



// WEBPACK FOOTER //
// ./src/components/basic/inputs/LinkedInput.js